module.exports = __webpack_public_path__ + "static/fonts/wizard.f08458a0.woff";